import { createFileRoute } from "@tanstack/react-router";
import { MeetCharacter } from "@/lib/lazyPages";
import { characterHeadSeo } from "@/lib/seo/characters";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/characters/$name")({
  head: ({ params }) =>
    seoHead({ ...characterHeadSeo(params.name, `/characters/${params.name}`), noindex: true }),
  component: MeetCharacter,
});
